/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Lucio API
 * Lucio AI Outlook Add-in Backend API
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query';

import type {
  ErrorResponse,
  PostTranscriptionTranscribe200,
  PostTranscriptionTranscribeBody
} from '../lucioAPI.schemas';

import { customInstance } from '../../mutator';




/**
 * Transcribe an audio file using AI. Supports locale-aware transcription. Max file size: 5MB.
 * @summary Transcribe audio
 */
export const postTranscriptionTranscribe = (
    postTranscriptionTranscribeBody: PostTranscriptionTranscribeBody,
 signal?: AbortSignal
) => {
      
      const formData = new FormData();
formData.append(`audio`, postTranscriptionTranscribeBody.audio)
if(postTranscriptionTranscribeBody.language !== undefined) {
 formData.append(`language`, postTranscriptionTranscribeBody.language)
 }

      return customInstance<PostTranscriptionTranscribe200>(
      {url: `/transcription/transcribe`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      );
    }
  


export const getPostTranscriptionTranscribeMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTranscriptionTranscribe>>, TError,{data: PostTranscriptionTranscribeBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postTranscriptionTranscribe>>, TError,{data: PostTranscriptionTranscribeBody}, TContext> => {

const mutationKey = ['postTranscriptionTranscribe'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postTranscriptionTranscribe>>, {data: PostTranscriptionTranscribeBody}> = (props) => {
          const {data} = props ?? {};

          return  postTranscriptionTranscribe(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostTranscriptionTranscribeMutationResult = NonNullable<Awaited<ReturnType<typeof postTranscriptionTranscribe>>>
    export type PostTranscriptionTranscribeMutationBody = PostTranscriptionTranscribeBody
    export type PostTranscriptionTranscribeMutationError = ErrorResponse

    /**
 * @summary Transcribe audio
 */
export const usePostTranscriptionTranscribe = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTranscriptionTranscribe>>, TError,{data: PostTranscriptionTranscribeBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postTranscriptionTranscribe>>,
        TError,
        {data: PostTranscriptionTranscribeBody},
        TContext
      > => {

      const mutationOptions = getPostTranscriptionTranscribeMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    